module.exports = __webpack_public_path__ + "img/atcbanner.09926b14.png";